module.exports = __webpack_public_path__ + "img/work2.e628cada.gif";